export default class OperationRedirect {
    constructor(config = {}) {
        this.currentPath = config.currentPath || '/betrieb';
        this.defaultLang = config.defaultLang || 'de';
        this.selectId = config.selectId || 'lang-chooser';
        this.localStorageKey = config.localStorageKey || 'operationRedirected';

        this.init();
    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            if (this.isOnCurrentPage() && !this.hasRedirectedBefore()) {
                this.supportedLanguages = this.getSupportedLanguages();

                if (this.shouldRedirect()) {
                    this.handleRedirect();
                }
            }
        });
    }

    isOnCurrentPage() {
        return window.location.pathname === this.currentPath;
    }

    getBrowserLanguage() {
        const userLang = navigator.language || navigator.userLanguage;
        return userLang ? userLang.toLowerCase().slice(0, 2) : null; // 'en', 'fr', etc.
    }

    getSupportedLanguages() {
        const langSelect = document.getElementById(this.selectId);
        if (!langSelect) return [];

        return Array.from(langSelect.options).map(option => {
            const match = option.value.match(/\/([a-z]{2})\//);
            return match ? match[1] : null;
        }).filter(lang => lang && lang !== this.defaultLang); // Exclude default language
    }

    shouldRedirect() {
        const browserLang = this.getBrowserLanguage();
        return browserLang && browserLang !== this.defaultLang && this.supportedLanguages.includes(browserLang);
    }

    hasRedirectedBefore() {
        return localStorage.getItem(this.localStorageKey) === 'true';
    }

    markRedirected() {
        localStorage.setItem(this.localStorageKey, 'true');
    }

    handleRedirect() {
        const browserLang = this.getBrowserLanguage();
        const langSelect = document.getElementById(this.selectId);

        if (langSelect) {
            const targetOption = Array.from(langSelect.options).find(option => option.value.includes(`/${browserLang}/`));

            if (targetOption && !targetOption.selected) {
                this.markRedirected(); // Prevent future redirects

                langSelect.value = targetOption.value;

                // Trigger change event if needed
                const event = new Event('change', { bubbles: true });
                langSelect.dispatchEvent(event);

                // Optional: direct redirect
                window.location.href = targetOption.value;
            }
        }
    }
}
